module.exports = __webpack_public_path__ + "img/firma.bc7ef456.png";